import React, { useMemo } from 'react';
import Suggestions from 'design-system/suggestions/Suggestions';
import { useAppSelector } from 'store/hooks';
import checkFeatureFlag from 'utils/featureFlags';
import { CATEGORY_SUGGESTIONS, DEFAULT_SUGGESTIONS } from './suggestions';
const CustomCategorySuggestions = ({ name, handleSuggestionPress, suggestedData, parentCategory, }) => {
    const showSubcategoriesCreateFlow = useAppSelector((store) => checkFeatureFlag(store.utils.featureFlags, 'show_subcategories_create_flow'));
    const suggestions = useMemo(() => {
        if (!parentCategory || !showSubcategoriesCreateFlow) {
            return DEFAULT_SUGGESTIONS;
        }
        return CATEGORY_SUGGESTIONS[parentCategory.id] || [];
    }, [parentCategory, showSubcategoriesCreateFlow]);
    if (!suggestions.length) {
        return null;
    }
    return (<Suggestions title="Suggestions" data={suggestions} name={name} handleSuggestionPress={handleSuggestionPress} suggestedData={suggestedData}/>);
};
export default CustomCategorySuggestions;
